// Volumetric colors ordered from lightest (greenish blue) to darkest (blue)
const BLACK = '#000';
const WHITE = '#FFF';
const v50 = { main: '#DCECC9', contrastText: BLACK };
const v100 = { main: '#AADACC', contrastText: BLACK };
const v200 = { main: '#78C6D0', contrastText: BLACK };
const v300 = { main: '#48B3D3', contrastText: BLACK };
const v400 = { main: '#3E94C0', contrastText: BLACK };
export const v500 = { main: '#3474AC', contrastText: WHITE };
const v600 = { main: '#2A5599', contrastText: WHITE };
const v700 = { main: '#203686', contrastText: WHITE };
const v800 = { main: '#18216B', contrastText: WHITE };
const v900 = { main: '#11174B', contrastText: WHITE };

// Categorical colors ordered from lightest (yellow) to darkest (blue)
const c1 = {
  main: '#F8DFA0',
  light: 'rgb(248,223,160,0.2)',
  contrastText: BLACK
};
const c2 = {
  main: '#F3C05C',
  light: 'rgb(243,192,92,0.2)',
  contrastText: BLACK
};
const c3 = {
  main: '#FF8E5E',
  light: 'rgb(255,142,94,0.2)',
  contrastText: BLACK
};
const c4 = {
  main: '#EE6A70',
  light: 'rgb(238,106,112,0.2)',
  contrastText: BLACK
};
const c5 = {
  main: '#D45087',
  light: 'rgb(212,80,135,0.2)',
  contrastText: BLACK
};
const c6 = {
  main: '#A05195',
  light: 'rgb(160,81,149,0.2)',
  contrastText: WHITE
};
const c7 = {
  main: '#665191',
  light: 'rgb(102,81,145,0.2)',
  contrastText: WHITE
};
const c8 = {
  main: '#2F4B7C',
  light: 'rgb(47,75,124,0.2)',
  contrastText: WHITE
};
const c9 = {
  main: '#003F5C',
  light: 'rgb(0,63,92,0.2)',
  contrastText: WHITE
};
const c10 = {
  main: '#002440',
  light: 'rgb(0,36,64,0.2)',
  contrastText: WHITE
};

export const dMin = '#43A7C4';
export const dMid = '#F1F1F1';
export const dMax = '#E37E54';

const divergentTransform = (numWhites, colors) =>
  colors
    .map((color, idx) => ({
      main: color,
      contrastText: idx < numWhites || colors.length - idx <= numWhites ? WHITE : BLACK
    }))
    .reverse();

export default {
  volumetricColors: {
    1: [v500],
    2: [v500, v300],
    3: [v500, v300, v100],
    4: [v900, v500, v300, v100],
    5: [v900, v700, v500, v300, v100],
    6: [v900, v700, v500, v300, v200, v100],
    7: [v900, v800, v700, v500, v300, v200, v100],
    8: [v900, v800, v700, v600, v500, v300, v200, v100],
    9: [v900, v800, v700, v600, v500, v300, v200, v100, v50],
    10: [v900, v800, v700, v600, v500, v400, v300, v200, v100, v50]
  },

  categoricalColors: {
    1: [c8],
    2: [c8, c4],
    3: [c8, c4, c2],
    4: [c8, c6, c4, c2],
    5: [c10, c8, c6, c4, c2],
    6: [c10, c8, c6, c4, c3, c2],
    7: [c10, c9, c8, c6, c4, c3, c2],
    8: [c10, c9, c8, c7, c6, c4, c3, c2],
    9: [c10, c9, c8, c7, c6, c4, c3, c2, c1],
    10: [c10, c9, c8, c7, c6, c5, c4, c3, c2, c1]
  },

  divergentColors: {
    0: [],
    1: divergentTransform(1, [dMid]),
    3: divergentTransform(1, [dMin, dMid, dMax]),
    5: divergentTransform(1, [dMin, '#A3CBDA', dMid, '#F1B7A0', dMax]),
    7: divergentTransform(1, [
      dMin,
      '#87BFD3',
      '#BED8E2',
      dMid,
      '#F2CABA',
      '#EDA486',
      dMax
    ]),
    9: divergentTransform(2, [
      dMin,
      '#79B9CF',
      '#A3CBDA',
      '#CBDEE5',
      dMid,
      '#F3D4C8',
      '#F1B7A0',
      '#EB9B7A',
      dMax
    ]),
    11: divergentTransform(3, [
      dMin,
      '#6FB6CD',
      '#93C4D6',
      '#B3D3DF',
      '#D2E2E8',
      dMid,
      '#F3DAD0',
      '#F2C3B0',
      '#EFAC90',
      '#EA9572',
      dMax
    ]),
    13: divergentTransform(4, [
      dMin,
      '#69B3CB',
      '#87BFD3',
      '#A3CBDA',
      '#BED8E2',
      '#D7E4E9',
      dMid,
      '#F2DDD5',
      '#F2CABA',
      '#F1B7A0',
      '#EDA486',
      '#E9916D',
      dMax
    ])
  },

  // Used in Student Mastery Perceptions / Perception Picker, Student Portfolio / Student Growth
  level3: v300,
  level2: v100,
  level1: c4,
  level0: { main: '#A6ADAF', contrastText: BLACK },

  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#efedec',
    300: '#e1dedc',
    400: '#bebbaf',
    500: '#9f9d9b',
    600: '#767473',
    700: '#625f5d',
    800: '#43413f',
    900: '#22201e',
    950: '#191614'
  }
};
